import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
// import HeaderLogo from "../../assets/images/header-logo.png";

const FooterDiv = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  flex-wrap: nowrap;
  padding-top: 60px;
  padding-bottom: 70px;
`;

const MenuDiv = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
  width: auto;

  @media screen and (max-width: 960px) {
    align-items: center;
    width: 100%;
  }
`;

const MenuItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: nowrap;
  margin-right: 40px;

  &:last-child {
    margin-right: 0;
  }

  @media screen and (max-width: 960px) {
    width: 50%;
    margin-right: 0;
    margin-bottom: 16px;
  }
`;

const MenuTitle = styled.span`
  color: #e9ecef;
  font-weight: 400;
  font-size: 16px;
  line-height: 28px;
  letter-spacing: -0.1px;
`;

const InfoDiv = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  flex-wrap: nowrap;
  width: 100%;
  padding-top: 16px;
  padding-bottom: 16px;
`;

const InfoTitle = styled.p`
  color: #e9ecef;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: -0.1px;
  margin-bottom: 8px;
`;

const InfoDetail = styled.p`
  color: #888e94;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: -0.1px;
`;

const InfoLine = styled.div`
  flex: none;
  background-color: #888e94;
  width: 100%;
  height: 1px;
  margin-bottom: 16px;
`;

const SNSDiv = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
  width: auto;
  margin-bottom: 8px;
`;

const SNSItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: nowrap;
  margin-right: 24px;

  &:last-child {
    margin-right: 0;
  }
`;

const SNSTitle = styled.span`
  color: #888e94;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: -0.1px;
`;

const CorpDiv = styled(SNSDiv)``;
const CorpItem = styled(SNSItem)``;
const CorpTitle = styled(SNSTitle)``;
const CorpPrivacyTitle = styled.p`
  color: #e9ecef;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: -0.1px;
`;

const Footer = () => {
  // english version of the footer component
  return (
    <footer>
      <div className="container">
        <FooterDiv>
          <MenuDiv>
            <MenuItem>
              <Link to="https://indip.io">
                {/* <MenuTitle>회사소개</MenuTitle> */}
                <MenuTitle>About Us</MenuTitle>
              </Link>
            </MenuItem>
            <MenuItem>
              <Link to="https://indip.io/news">
                {/* <MenuTitle>언론보도</MenuTitle> */}
                <MenuTitle>NEWS</MenuTitle>
              </Link>
            </MenuItem>
            <MenuItem onClick={()=>{alert("준비중입니다.")}}>
              {/* <Link to="/about"> */}
                {/* <MenuTitle>이용가이드</MenuTitle> */}
                <MenuTitle>User Guide</MenuTitle>
              {/* </Link> */}
            </MenuItem>
            <MenuItem onClick={()=>{alert("준비중입니다.")}}>
              {/* <Link to="/about"> */}
                {/* <MenuTitle>이용후기</MenuTitle> */}
                <MenuTitle>User Reviews</MenuTitle>
              {/* </Link> */}
            </MenuItem>
            <MenuItem onClick={()=>{alert("준비중입니다.")}}>
              {/* <Link to="/about"> */}
                {/* <MenuTitle>공지사항</MenuTitle> */}
                <MenuTitle>Notice</MenuTitle>
              {/* </Link> */}
            </MenuItem>
          </MenuDiv>

          <InfoDiv>
            {/* <InfoTitle>인디프 | 변리사 매칭은, 인디프</InfoTitle> */}
            <InfoTitle>Indieip | Patent Attorney Matching, Indieip</InfoTitle>
            {/* <InfoDetail>원하는 변리사를 직접 만나보세요</InfoDetail> */}
            <InfoDetail>Meet your desired patent attorney directly</InfoDetail>
          </InfoDiv>

          <InfoDiv>
            {/* <InfoTitle>(주) 인디프</InfoTitle> */}
            <InfoTitle>Indieip Co., Ltd.</InfoTitle>
            {/* <InfoDetail className="mb-16">
              사업자등록번호: 507-53-00884 | 대표이사: 손보남 | 주소: 서울 서대문구 명지2길 33, MJC창업센터2, 101호
            </InfoDetail> */}
            <InfoDetail className="mb-16">
              Business Registration Number: 507-53-00884 | CEO: Son Bonam | Address: 33 Myongji 2-gil, Seodaemun-gu, Seoul, MJC Startup Center 2, Room 101
            </InfoDetail>
            {/* <InfoDetail>
              본 웹사이트는 일반적인 정보 제공의 목적으로 제작된 것으로 법률적 자문이나 해석을 위하여 제공되는 것이
              아닙니다. 본 웹사이트에서 취득한 정보로 인해 문제가 발생하여 직·간접적인 손해를 입었다 하더라도
              (주)인디프는 어떠한 법적 책임을 지지 않습니다. 본 웹사이트에서 취득한 정보를 바탕으로 하여 어떠한 조치를
              취하시기에 앞서 반드시 법률전문가와 충분한 상담을 진행하시기 바랍니다.
              <br />
              (주)인디프는 공정한 수임질서를 지키기 위해 노력하며 변리사법 및 기타 관련 규정을 준수하고 있습니다. 모든
              특허상담은 인디프에 가입한 변리사 회원이 직접 진행합니다. 인디프에 표시된 변리사 회원의 정보는 해당 변리사
              회원이 직접 제공한 것이며, 모든 변리사 회원은 독립적으로 업무를 수행합니다.
            </InfoDetail> */}
            <InfoDetail>
              This website is created for general information purposes and is not intended to provide legal advice or interpretation. Indieip Co., Ltd. assumes no legal responsibility for any direct or indirect damages arising from issues related to the information obtained from this website. Before taking any action based on the information obtained, please consult with a legal professional.
              <br />
              Indieip Co., Ltd. strives to maintain fair engagement practices and complies with the Patent Attorney Act and other relevant regulations. All patent consultations are conducted directly by patent attorney members registered with Indieip. The information displayed about patent attorney members on Indieip is provided directly by those members, and all patent attorney members operate independently.
            </InfoDetail>
          </InfoDiv>
          <InfoLine />

          <SNSDiv>
            <SNSItem>
              <Link to="/home">
                <SNSTitle>Naver Blog</SNSTitle>
              </Link>
            </SNSItem>
            <SNSItem>
              <Link to="/home">
                <SNSTitle>INSTAGRAM</SNSTitle>
              </Link>
            </SNSItem>
            <SNSItem>
              <Link to="/home">
                <SNSTitle>LinkedIn</SNSTitle>
              </Link>
            </SNSItem>
            <SNSItem>
              <Link to="/home">
                <SNSTitle>KAKAO</SNSTitle>
              </Link>
            </SNSItem>
          </SNSDiv>

          <CorpDiv>
            <CorpItem>
              <CorpTitle>© 2023 Indieip</CorpTitle>
            </CorpItem>
            <CorpItem onClick={()=>{alert("준비중입니다.")}}>
              {/* <Link to="#"> */}
                <CorpPrivacyTitle>Privacy Policy</CorpPrivacyTitle>
              {/* </Link> */}
            </CorpItem>
            <CorpItem onClick={()=>{alert("준비중입니다.")}}>
              {/* <Link to="/about"> */}
                <CorpPrivacyTitle>Terms of Service</CorpPrivacyTitle>
              {/* </Link> */}
            </CorpItem>
            <CorpItem>
              <CorpTitle>Email : indieip@indieip.co.kr</CorpTitle>
            </CorpItem>
            <CorpItem>
              <CorpTitle>Phone : +0507-1304-6037</CorpTitle>
            </CorpItem>
          </CorpDiv>
        </FooterDiv>
      </div>
    </footer>
  );
};

export default Footer;
